import * as React from "react"
import type { SVGProps } from "react"
const SvgGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 1.042a8.958 8.958 0 1 0 0 17.916 8.958 8.958 0 0 0 0-17.916m-1.42 1.38a7.712 7.712 0 0 0-6.263 6.953h3.752A13.375 13.375 0 0 1 8.58 2.422m2.84 0a13.376 13.376 0 0 1 2.511 6.953h3.752a7.713 7.713 0 0 0-6.263-6.953m1.258 6.953A12.126 12.126 0 0 0 10 2.624a12.125 12.125 0 0 0-2.678 6.751zm-5.356 1.25h5.356A12.126 12.126 0 0 1 10 17.376a12.126 12.126 0 0 1-2.678-6.751m-1.253 0H2.317a7.712 7.712 0 0 0 6.263 6.953 13.375 13.375 0 0 1-2.511-6.953m5.351 6.953a13.375 13.375 0 0 0 2.511-6.953h3.752a7.713 7.713 0 0 1-6.263 6.953"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGlobe
